<template>
  <van-row class="size30 color21 paddBott120">
    <!--在线客服-->
    <!--<van-row class="backF padding30 marBott30" v-if="channelConfig.displayOnlineCustomer">-->
      <!--<van-row class="themeColor size32 marBott30">在线客服</van-row>-->
      <!--<van-row type='flex'>-->
        <!--<img src="../../../static/images/online.png" alt="" class="serviceIcon">-->
        <!--<van-row type='flex' class="flex1" justify='space-between'>-->
          <!--<van-row type='flex' class="flexDirection marLeft30" justify='space-between'>-->
            <!--<van-row>人工客服</van-row>-->
            <!--<van-row class="size28 color99">工作日  09:00-18:00</van-row>-->
          <!--</van-row>-->
          <!--<van-row type='flex' id="abc" class="flexDirection paddLeft30 borderLeftDD" justify='space-between' align='center'>-->
            <!--<i class="iconfont iconxiaoxi size36 themeColor"></i>-->
            <!--<van-row class="size22 color99">点我咨询</van-row>-->
          <!--</van-row>-->
        <!--</van-row>-->
      <!--</van-row>-->
    <!--</van-row>-->

    <van-row class="backF padding30 marBott30" >
      <van-row class="themeColor size32">投保客服</van-row>
      <div v-if="customerJson">
        <van-row type='flex' v-for="(item,i) in customerJson" :key="i" class="paddTop30 paddBott30 borderBottF2" >
          <img :src="serviceImg" alt="" class="serviceIcon">
          <van-row type='flex' class="flex1" justify='space-between'>
            <van-row type='flex' class="flexDirection marLeft30" justify='space-between'>
              <van-row>{{item.customerServiceName}}</van-row>
              <van-row class="size28 color99">{{item.customerServiceTime}}</van-row>
            </van-row>
            <a :href="'tel:'+item.customerServiceTel">
              <van-row type='flex' class="flexDirection paddLeft30 borderLeftDD" justify='space-between' align='center'>
                <i class="iconfont iconboda12 size36 themeColor"></i>
                <van-row class="size22 color99 marTop10">点击拨打</van-row>
              </van-row>
            </a>
          </van-row>
        </van-row>
      </div>
      <div v-else class="size24 color99 marTop20" >暂无配置客服...</div>
    </van-row>

    <van-row class="backF padding30" v-if="false">
      <van-row class="themeColor size32 marBott30">理赔客服</van-row>
      <van-row type='flex' align='center' class="paddBott30 borderBottF2">
        <img src="../../../static/images/insurance/PA.png" alt="" class="pinanIcon">
        <van-row type='flex' class="flex1 paddLeft80" justify='space-between' align='center'>
          <van-row>95511</van-row>
          <van-row type='flex' class="flexDirection paddLeft30 borderLeftDD" justify='space-between' align='center'>
            <i class="iconfont iconboda12 size36 themeColor"></i>
            <van-row class="size22 color99 marTop20">点击拨打</van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-row>
    <van-row class="backF padding30" v-if="false">
      <van-row class="themeColor size32 marBott30">理赔客服</van-row>
      <van-row type='flex' align='center' class="paddBott30 borderBottF2">
        <img src="../../../static/images/insurance/PICC.png" alt="" class="renbaoIcon">
        <van-row type='flex' class="flex1 paddLeft80" justify='space-between' align='center'>
          <van-row>95511</van-row>
          <van-row type='flex' class="flexDirection paddLeft30 borderLeftDD" justify='space-between' align='center'>
            <i class="iconfont iconboda12 size36 themeColor"></i>
            <van-row class="size22 color99 marTop20">点击拨打</van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-row>
    <van-row class="backF padding30" v-if="false">
      <van-row class="themeColor size32 marBott30">理赔客服</van-row>
      <van-row type='flex' align='center' class="paddBott30">
        <img src="../../../static/images/insurance/TP.png" alt="" class="taipIcon">
        <van-row type='flex' class="flex1 paddLeft80" justify='space-between' align='center'>
          <van-row>95511</van-row>
          <van-row type='flex' class="flexDirection paddLeft30 borderLeftDD" justify='space-between' align='center'>
            <i class="iconfont iconboda12 size36 themeColor"></i>
            <van-row class="size22 color99 marTop20">点击拨打</van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-row>
    <template>
      <van-row class="foot app" v-if="!isFootTab">
        <van-row class="XYcenter textCenter app height100">
          <van-row class="footBoxLeft size30 XYcenter color66 app height100 menu_left_on colorF">
            <i class="iconfont iconkefu size60"></i>客服
          </van-row>
          <van-row class="footBoxRight size30 XYcenter color66 app height100"
                   @click="tabClick('home','3')">
            <i class="iconfont icondingdan1 size60"></i>订单
          </van-row>
          <van-row type="flex" align="center" justify="center"
                   class="homeBtn color66 flexDirection backF"
                   @click="tabClick('home','2')">
            <div class="iconfont iconshouye1 size60"></div>
            <div class="size30">首页</div>
          </van-row>
        </van-row>
      </van-row>
      <!--<foot-tab v-show="!isFootTab" type="home" status="1" @tabClick="tabClick"></foot-tab>-->
    </template>

  </van-row>
</template>

<script type="es6">
  // import footTab from '../base/footTab'
  import ChannelConfig from "../../public/ChannelConfig";//渠道信息变量
  export default {
    // components: {footTab},
    // props:['isFootTab'],
    props: {
      isFootTab: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        orderId:'',
        channelCode:'',
        channelConfig:JSON.parse(JSON.stringify(ChannelConfig)),// TODO 渠道信息变量
        customerJson:[],
        // isFootTab:false,
        serviceImg:this.$store.state.themeImgRootPath+"customerService.png",
      }
    },
    watch: {},//监听
    created() {
      console.log(this.isFootTab)
      this.orderId = this.commonJs.getQueryString('orderId') || this.$route.query.orderId;
      this.channelCode = this.commonJs.getQueryString('channelCode') || this.$route.query.channelCode || sessionStorage['channelCode'];
      if(sessionStorage['channelConfig']){
        this.channelConfig = JSON.parse(sessionStorage['channelConfig']);
        this.customerJson = JSON.parse(this.channelConfig.customerJson);
        console.log(this.customerJson)
      }else{
        this.commonJs.backChannelData(this.orderId,this.channelCode,data=>{
          this.channelCode = data.channelCode
          this.channelConfig = data
        })
      }
    },
    mounted() {
      // if(sessionStorage.getItem('channelConfig')!=null){
      //   var config = JSON.parse(sessionStorage.getItem('channelConfig'));
      //   if(config.displayOnlineCustomer){
      //     this.onlineService = true;
      //     //先移除js
      //     var scripts = document.getElementsByTagName("script");
      //     for (var i = 0; i < scripts.length; i++) {
      //       if(scripts[i].id=="qidiankf"){
      //         scripts[i].parentNode.removeChild(scripts[i]);
      //       }
      //     }
      //     const js = document.createElement('script');
      //     js.id = "qidiankf";
      //     js.async = true;
      //     js.defer = true;
      //     js.src = config.onlineCustomerJs;
      //     document.body.appendChild(js);
      //   }
      // }
    },
    methods: {
      tabClick(type,status){
        if(status == 2){
          this.$router.push({path:`/home`,query:{orderId:this.orderId,channelCode:this.channelCode}})
        }else if(status == 3){
          this.$router.push({path:`/myOrder`,query:{orderId:this.orderId,channelCode:this.channelCode}})
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_handle.scss";
.serviceIcon{
  width: 8rem;
  height: 8rem;
}
.pinanIcon{
  width: 10.5rem;
}
.renbaoIcon{
  width: 10.5rem;
}
.taipIcon{
  width: 12rem;
}
.foot{
  position: fixed;
  bottom: 0;
  left: 0;
  height: 12rem;
  z-index: 9;
  /* box-shadow: 0px 0px 15px 1px
      rgba(208, 208, 208, 0.76); */
}
.positionButt120{
  position: absolute;
  left: 0;
  bottom:12rem;
}
.footBoxLeft{
  background: url('../../assets/menu_left.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 3px;
}
.bgColor{
  background: linear-gradient(to bottom, $mainColor 0%, $mainColor 100%);
}
.footBoxRight{
  background: url('../../assets/menu_right.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 3px;
}
.menu_left_on {
  @include backgroundImage("menu_left_on.png");
  background-size: 100% 100%;
  padding-top: 3px;
}
.menu_right_on{
  @include backgroundImage("menu_right_on.png");
  background-size: 100% 100%;
  padding-top: 3px;
}
/*.footBoxRightBlueClick{*/
/*background: url('../../assets/menu_right_on.png') no-repeat;*/
/*background-size: 100% 100%;*/
/*padding-top: 3px;*/
/*color: #fff !important;*/
/*}*/

.homeBtn {
  position: absolute;
  width: 15rem;
  height: 15rem;
  bottom: 3rem;
  left: 50%;
  transform: translate(-50%, 0px);
  z-index: 10;
  border-radius: 50%;
  box-shadow: 0px 2px 11px 2px rgba(157, 157, 157, 0.42);
}
.clickStyle{
  color:#FFFFFF !important;
  background-color: $mainColor !important;
}
.buttMoreBox{
  width: 22rem;
  padding: 3rem 0;
}
/deep/ .bottom60{
  height: calc(100% - 12rem) !important;
}
.bottom60 + .van-popup{
  bottom: 12rem !important;
}
.disabledButt{
  cursor: not-allowed;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/customerService/customerService.vue